import React from "react";

interface Option {
  id: string;
  label: string;
}

interface QuestionStepProps {
  question: string;
  helpText?: string;
  options: Option[];
  selectedOptionId: string | null;
  onSelect: (id: string) => void;
}

const QuestionStep: React.FC<QuestionStepProps> = ({
  question,
  helpText,
  options,
  selectedOptionId,
  onSelect,
}) => {
  return (
    <div className="max-w-2xl mx-auto text-gray-800">
      <h2 className="text-xl font-semibold mb-2">{question}</h2>
      {helpText && (
        <p className="text-sm text-gray-500 italic mb-4">{helpText}</p>
      )}
      <div className="flex flex-col gap-3">
        {options.map((opt) => (
          <label
            key={opt.id}
            className={`flex items-center gap-3 px-4 py-3 rounded-lg border cursor-pointer text-base transition-all
              ${selectedOptionId === opt.id
                ? 'border-blue-600 bg-blue-50 text-blue-700'
                : 'border-gray-200 text-gray-600 hover:border-blue-300 hover:bg-gray-50'
              }`}
          >
            <input
              type="radio"
              name="question"
              value={opt.id}
              checked={selectedOptionId === opt.id}
              onChange={() => onSelect(opt.id)}
              className="w-4 h-4 cursor-pointer accent-blue-600"
            />
            {opt.label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default QuestionStep;
